import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Shield } from 'lucide-react';

export default function SuperAdminLoginPage() {
  const { loginSuperAdmin } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handle = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginSuperAdmin(form.email, form.password);
      navigate('/superadmin');
    } catch (err) {
      const msg = err.response?.data?.error;
      if (msg === 'Invalid credentials') {
        setError('E-Mail oder Passwort ist falsch');
      } else {
        setError(msg || 'Anmeldung fehlgeschlagen');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: 16, background: 'var(--surface)', border: '1px solid var(--border)', marginBottom: 16 }}>
            <Shield size={26} color="var(--primary)" strokeWidth={1.5} />
          </div>
          <h1 style={{ fontFamily: 'Playfair Display', fontSize: 36, color: 'var(--primary-dk)', letterSpacing: -1 }}>
            Ilmi<span style={{ color: 'var(--accent)' }}>fy</span>
          </h1>
          <p style={{ color: 'var(--text3)', fontSize: 13, marginTop: 4 }}>Super-Admin-Bereich</p>
        </div>

        <div className="card">
          <h2 style={{ fontSize: 18, marginBottom: 4 }}>Administrator-Anmeldung</h2>
          <p style={{ color: 'var(--text3)', fontSize: 13, marginBottom: 20 }}>
            Nur für autorisierte Administratoren
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">E-Mail</label>
              <input
                className="form-input"
                type="email"
                name="email"
                value={form.email}
                onChange={handle}
                required
                autoFocus
                placeholder="admin@ilmify.ch"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Passwort</label>
              <input
                className="form-input"
                type="password"
                name="password"
                value={form.password}
                onChange={handle}
                required
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%', marginTop: 20 }}
              disabled={loading || !form.email || !form.password}
            >
              {loading ? 'Laden...' : 'Anmelden'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
